import React from 'react';
import useReveal from '../hooks/useReveal';
const REPOS = [
  {
    ico: '🚀',
    badges: ['Python', 'Django', 'Docker'],
    mono: 'django-production-starter',
    title: 'Django Production Starter Kit',
    desc: 'A production-ready Django starter template designed to eliminate the first week of setup. Ships with REST APIs, PostgreSQL, JWT authentication, Docker, and a clean multi-environment configuration.',
    feats: [
      'Django REST Framework with versioned API structure',
      'PostgreSQL + pgAdmin setup out of the box',
      'JWT authentication (access + refresh tokens)',
      'Docker + Docker Compose for local dev and deployment',
      'Staging/production environment-based settings',
      'GitHub Actions CI/CD template included',
      'Pre-configured logging, error handling, and CORS',
    ],
    url:'https://github.com/arhat-info/django-production-starter',
    document_url:'/django_setup_guide.pdf'
  },
  // {
  //   ico: '🧠',
  //   badges: ['Django', 'OpenAI', 'RAG'],
  //   mono: 'django-openai-knowledgebase',
  //   title: 'Django + OpenAI Knowledgebase Starter',
  //   desc: 'A complete starter for building AI-powered knowledgebase applications. Combines Django\'s robust admin and content management with OpenAI\'s language models for semantic search and Q&A.',
  //   feats: [
  //     'Document and content models with rich metadata',
  //     'REST APIs for content ingestion and retrieval',
  //     'OpenAI query endpoint with context injection',
  //     'Prompt templates with easy customization',
  //     'Structured response format with source citations',
  //     'Django admin panel for content management',
  //     'pgvector support for semantic similarity search',
  //   ],
  //   url:'',
  //   document_url:''
  // },
  // {
  //   ico: '📑',
  //   badges: ['Python', 'OCR', 'LLM'],
  //   mono: 'ai-document-processing-pipeline',
  //   title: 'AI Document Processing Pipeline',
  //   desc: 'A Python-based pipeline for extracting structured data from documents using OCR and LLMs. Designed to be API-ready and easy to extend for different document types and extraction schemas.',
  //   feats: [
  //     'PDF and image upload support',
  //     'OCR extraction via Tesseract or AWS Textract',
  //     'LLM-based structured JSON output with Pydantic models',
  //     'Confidence scoring per field',
  //     'Human-review queue integration pattern',
  //     'API-ready design with FastAPI wrapper',
  //     'Extensible schema definitions for any document type',
  //   ],
  //   url:'',
  //   document_url:''
  // },
  // {
  //   ico: '🖥️',
  //   badges: ['Ubuntu', 'DevOps', 'Remote'],
  //   mono: 'developer-vdi-setup',
  //   title: 'VDI / Remote Workspace Setup Guide',
  //   desc: 'A practical guide and automation scripts for setting up secure virtual development environments for remote engineering teams — from bare Ubuntu to a fully productive Python/Django development machine.',
  //   feats: [
  //     'Ubuntu 22.04 base configuration scripts',
  //     'Python, pyenv, virtualenv environment setup',
  //     'Docker and Docker Compose installation',
  //     'SSH key generation and GitHub configuration',
  //     'Security hardening checklist and firewall rules',
  //     'VS Code Remote SSH configuration guide',
  //     'Remote developer onboarding runbook',
  //   ],
  //   url:'',
  //   document_url:''
  // },
];

export default function OpenSource() {
  useReveal();
  return (
    <div className="page">
      <div className="ph rv">
        <div className="s-label">Open Source</div>
        <h1>Developer Tools &amp;<br />Starter Templates</h1>
        <p className="lead">Open-source libraries and production-ready templates to help teams ship Django, AI, and automation projects faster — without reinventing the wheel.</p>
      </div>

      <section className="section" style={{ paddingTop: 0 }}>
        <div className="wrap">
          <div className="repo-grid">
            {REPOS.map((r, i) => (
              <div key={i} className={`repo-card rv d${i + 1}`}>
                <div style={{ fontSize: '2rem' }}>{r.ico}</div>
                <div className="repo-badges">
                  {r.badges.map(b => <span key={b} className="repo-badge">{b}</span>)}
                </div>
                <div className="repo-mono">{r.mono}</div>
                <h3>{r.title}</h3>
                <p>{r.desc}</p>
                <ul className="repo-feats">
                  {r.feats.map(f => <li key={f}>{f}</li>)}
                </ul>
                <div className="repo-footer">
                  <a href={r.url} target="_blank" rel="noreferrer" className="repo-btn repo-btn-p">View on GitHub →</a>
                  <a href={r.document_url} target="_blank" rel="noreferrer" className="repo-btn repo-btn-g">Documentation</a>
                </div>
              </div>
            ))}
          </div>

          {/* Contribute box */}
          <div className="rv" style={{ marginTop: '3rem', background: 'linear-gradient(135deg,var(--bg3),rgba(59,130,246,.06))', border: '1px solid var(--border)', borderRadius: 'var(--r)', padding: '3rem', display: 'flex', alignItems: 'center', justifyContent: 'space-between', flexWrap: 'wrap', gap: '1.5rem' }}>
            <div>
              <h3 style={{ fontFamily: 'var(--font)', fontSize: '1.35rem', fontWeight: 800, letterSpacing: '-.03em', color: 'var(--white)', marginBottom: '.5rem' }}>Want to contribute or suggest a tool?</h3>
              <p style={{ fontSize: '.88rem', color: 'var(--muted)' }}>These repositories are actively maintained and open to contributions. Found a bug, have a feature request, or want to collaborate on a new template?</p>
            </div>
            <a href="https://github.com/arhat-info" target="_blank" rel="noreferrer" className="btn-p">GitHub Profile →</a>
          </div>
        </div>
      </section>
    </div>
  );
}
